import * as i0 from '@angular/core';
import { Directive, Input, HostListener, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

class FFForceUppercaseDirective {
    constructor(_el, _renderer) {
        this._el = _el;
        this._renderer = _renderer;
    }
    onInput(value) {
        const transformedValue = value.toUpperCase();
        this._renderer.setProperty(this._el.nativeElement, 'value', transformedValue);
    }
}
FFForceUppercaseDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FFForceUppercaseDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
FFForceUppercaseDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: FFForceUppercaseDirective, selector: "input[ffForceUppercase], textarea[ffForceUppercase]", inputs: { forceUppercase: "forceUppercase" }, host: { listeners: { "input": "onInput($event.target.value)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FFForceUppercaseDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[ffForceUppercase], textarea[ffForceUppercase]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { forceUppercase: [{
                type: Input
            }], onInput: [{
                type: HostListener,
                args: ['input', ['$event.target.value']]
            }] } });

class FFForceUppercaseModule {
}
FFForceUppercaseModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FFForceUppercaseModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FFForceUppercaseModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FFForceUppercaseModule, declarations: [FFForceUppercaseDirective], imports: [CommonModule], exports: [FFForceUppercaseDirective] });
FFForceUppercaseModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FFForceUppercaseModule, providers: [], imports: [[
            CommonModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FFForceUppercaseModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    exports: [FFForceUppercaseDirective],
                    declarations: [FFForceUppercaseDirective],
                    providers: [],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FFForceUppercaseDirective, FFForceUppercaseModule };
